var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticClass: "detail-table",
      attrs: {
        data: _vm.list,
        fit: "",
        "header-cell-style": _vm.headerCellStyle,
        "cell-style": _vm.cellStyle,
      },
    },
    [
      _c("el-table-column", {
        attrs: { label: "项目名称", "min-width": "180" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "span",
                  {
                    staticClass: "text-cut",
                    attrs: { title: scope.row.gonggaoTitle },
                  },
                  [_vm._v(_vm._s(scope.row.gonggaoTitle))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "statusName",
          label: "状态",
          width: "180",
          align: "center",
        },
      }),
      _c("el-table-column", {
        attrs: { label: "操作", width: "120" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    staticClass: "select-btn",
                    attrs: { type: "primary", plain: "", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.viewDetail(row)
                      },
                    },
                  },
                  [_vm._v("选中查看")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }